import { BasicResponseDTO } from "@dto/basicResponse.dto";
import { AxiosError } from "axios";
import { NavigateOptions, To } from "react-router";
import { AllType, RoutePath } from "src/data/Routes";
import { MenuNode } from "src/model/MenuNode";
import { GLOB } from "src/util/Glob";

export interface Nav {
  to: To;
  options?: NavigateOptions;
}

export class NavResult {
  nav: Nav;
  tree: MenuNode;
  item: MenuNode;
}

/** URL segments and location of the route being navigated, as parsed by the route components. */
export interface NavContext {
  clsPath: RoutePath;
  allType: AllType;
  groupName: string;
  typeOrDevice: string;
  /** '/'-prefixed typeOrDevice, or null. */
  typeOrDevicePath: string;
  itemName: string;
  /** '/'-prefixed itemName plus the query string. */
  itemSearch: string;
  itemHash: string;
  location: { pathname: string; search: string; hash: string; };
}

/**
 * Domain-specific navigation behavior. Every hook is reached only through findNavDomain(),
 * so an implementation is called solely for the class route its matches() claims.
 */
export interface NavDomain {
  /** True when this domain owns the class route. */
  matches(clsPath: RoutePath): boolean;
  /** Redirect normalizing legacy/denormalized URLs, checked before any tree resolution. */
  normalize?(ctx: NavContext): Nav;
  /** Server URL resolving an item's menu path, when the domain has its own endpoint. */
  pathUrl?(itemSearch: string): string;
  /** Route to fall back to when loading the item's path failed, or undefined when unhandled. */
  loadErrorFallback?(reason: AxiosError<BasicResponseDTO>, urlGetPath: string): RoutePath | undefined;
}

/** Records the route segments of the currently displayed item on GLOB. */
export function commitSelection(clsPath: RoutePath, allType: AllType, groupId: string, typeOrDevicePath: string) {
  GLOB.selectedClass = clsPath;
  GLOB.selectedAllType = allType;
  GLOB.selectedGroupId = groupId;
  GLOB.selectedType = typeOrDevicePath;
}
